/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import moment from 'moment';
import classnames from 'classnames';
import BaseGrid from '../../components/Common/BaseGrid';
import { Can } from '../../utilities/Can';

function Fuse(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Nav tabs>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '1'),
              })}
              onClick={() => {
                toggle('1');
              }}
            >
              {t('Pending')}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              style={{ cursor: 'pointer' }}
              className={classnames({
                active: (activeTab === '2'),
              })}
              onClick={() => {
                toggle('2');
              }}
            >
              {t('Completed')}
            </NavLink>
          </NavItem>
        </Nav>

        <Row>
          <Col xxl="10">
            <TabContent activeTab={activeTab}>
              <TabPane key="chn_tab_1" tabId="1">
                <Card>
                  <CardBody>
                    <Can i="see" this="Fuse">
                      <BaseGrid
                        url="/api/fuse/workorder"
                        hasSearch
                        shouldPaginate
                        filters="pending"
                        className="table table-striped table-bordered fuse-workorder-table"
                        config={
                          {
                            rowClass: (ent) => {
                              if (ent.assigned_at === null && ent.finished_at === null) {
                                return 'table-info';
                              }

                              if (ent.finished_at !== null) {
                                return 'table-success';
                              }

                              if (ent.sale_items.some((x) => x.sale.distributions.length > 0)) {
                                return 'table-warning';
                              }

                              return '';
                            },
                            columns: {
                              id: {
                                label: 'ID',
                                sort: true,
                                link: {
                                  to: '/fuse/workorder/%id%',
                                },
                              },
                              created_at: {
                                label: props.t('Created'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              family: {
                                label: 'Family',
                                format: (f) => f.name,
                              },
                              listing: {
                                label: 'Listing',
                                format: (f) => f.sku,
                              },
                              assigned_to: {
                                label: t('Assigned To'),
                              },
                              assigned_at: {
                                label: t('Assigned At'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              finished_at: {
                                label: t('Finished At'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              qty: {
                                label: 'Qty',
                                format: (f, x) => x.sale_items.reduce((a, c) => a + c.qty, 0),
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'desc',
                              perPage: 30,
                            },
                          }
                        }
                      />
                    </Can>

                    <Can not i="see" this="Fuse"><p>{props.t('Unauthorized')}</p></Can>
                  </CardBody>
                </Card>
              </TabPane>
              <TabPane key="chn_tab_2" tabId="2">
                <Card>
                  <CardBody>
                    <Can i="see" this="Fuse">
                      <BaseGrid
                        url="/api/fuse/workorder"
                        hasSearch
                        shouldPaginate
                        filters="completed"
                        className="table table-striped table-bordered fuse-workorder-table"
                        config={
                          {
                            rowClass: (ent) => {
                              if (ent.assigned_at === null && ent.finished_at === null) {
                                return 'table-info';
                              }

                              if (ent.finished_at !== null) {
                                return 'table-success';
                              }

                              if (ent.sale_items.some((x) => x.sale.distributions.length > 0)) {
                                return 'table-warning';
                              }

                              return '';
                            },
                            columns: {
                              id: {
                                label: 'ID',
                                sort: true,
                                link: {
                                  to: '/fuse/workorder/%id%',
                                },
                              },
                              created_at: {
                                label: props.t('Created'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              family: {
                                label: 'Family',
                                format: (f) => f.name,
                              },
                              listing: {
                                label: 'Listing',
                                format: (f) => f.sku,
                              },
                              assigned_to: {
                                label: t('Assigned To'),
                              },
                              assigned_at: {
                                label: t('Assigned At'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              finished_at: {
                                label: t('Finished At'),
                                date: {
                                  format: (date) => (moment(date).fromNow()),
                                  timezone: process.env.LOCAL_TZ,
                                },
                                sort: true,
                                style: { fontSize: '11px' },
                              },
                              qty: {
                                label: 'Qty',
                                format: (f, x) => x.sale_items.reduce((a, c) => a + c.qty, 0),
                              },
                            },
                            pagination: {
                              sort: 'id',
                              direction: 'desc',
                              perPage: 30,
                            },
                          }
                        }
                      />
                    </Can>

                    <Can not i="see" this="Fuse"><p>{props.t('Unauthorized')}</p></Can>
                  </CardBody>
                </Card>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Fuse.defaultProps = {
  t: (x) => (x),
};

Fuse.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Fuse));
